import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FacturaGuia } from "./factura";
import { ResumenGuiaView } from "app/features/componentes/guia/resumenguia";
import { ReceptorFactura } from "../../facturas/edit/componentes/receptorfactura";
import { validarRFC, reglasValidacionRecpetor } from "app/logic/cliente";
import { DireccionFacturacionComponent } from "./direccionfacturaciononline";

type Entity = models.FacturaOnlineDTO;

interface Props {
    value: Entity;
    onFacturar: () => void;
    factura: models.FacturaDto;
    existeGuia: boolean;
    facturaOnline: models.FacturacionOnline;
    onChange: (value: models.FacturacionOnline) => PromiseLike<void> | void;
}

function validarReceptor(x: models.ReceptorFactura) {
    const rules: validation.Rules<models.ReceptorFactura> = {
        Rfc: validation.required,
        Nombre: validation.required
    };
    const rules2 = reglasValidacionRecpetor;
    const allRules = kea.validation.andRules(rules, rules2);
    return validation.getErrors(allRules, x);
}

function validarDireccion(x: models.Direccion) {
    const rules: validation.Rules<models.Direccion> = {
        Calle: validation.required,
        NoExterior: validation.required
    };

    const rules2 = reglasValidacionRecpetor;
    const allRules = kea.validation.andRules(rules);
    return validation.getErrors(allRules, x);
}

export function validar(x: models.FacturacionOnline) {

    const rules: validation.Rules<models.FacturacionOnline> = {
        IdColoniaFacturacionOnline: validation.required,
        CorreoFacturacion: validation.required,
        Receptor: validation.subrule(() => validarReceptor(x.Receptor)),
        DireccionFacturacionOnline: validation.subrule(() => validarDireccion(x.DireccionFacturacionOnline))
    };
    return validation.getErrors(rules, x);
}

class ResumenFacturacionViewNoRx extends React.PureComponent<Props> {

    facturaOnline = (props: Props) => props.facturaOnline;
    errors = createSelectorRx(this.facturaOnline, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));


    correoFacturacion = (props: Props) => props.facturaOnline.CorreoFacturacion;
    receptor = (props: Props) => props.facturaOnline.Receptor;
    factura = (props: Props) => props.factura;
    existeGuia = (props: Props) => props.existeGuia;

    private onReceptorChange = async (x: models.ReceptorFactura) => {
        const viejo = this.props.facturaOnline;
        const cambio: Partial<models.FacturacionOnline> = { Receptor: x }
        const nuevo = { ...viejo, ...cambio };
        if (this.props.onChange)
            await this.props.onChange(nuevo);
    }

    private onCorreoChange = async (x: string) => {
        const viejo = this.props.facturaOnline;
        const cambio: Partial<models.FacturacionOnline> = { CorreoFacturacion: x }
        const nuevo = { ...viejo, ...cambio };
        if (this.props.onChange)
            await this.props.onChange(nuevo);
    }

    onFacturarGuia = async () => {
        var folio = this.props.value.Folio;
        if (await kea.yesno("¿Facturar la guía: " + folio + "?")) {
            var guias = [folio];
            var value = this.props.facturaOnline;
            var params = { ...value, Folios: guias } as models.FacturacionOnline
            var idFactura = await resources.FacturacionGuia.FacturarGuiasOnline(params);
            await this.props.onFacturar();
            await kea.message("Se ha facturado la guía");
            location.reload();
        }
    }

    OnObtenerXML = async () => {
        const idFactura = this.props.factura.IdRegistro;
        if (idFactura != null) {
            const comprobanteXML = await resources.Factura.ObtenerXML(idFactura);
            kea.download(kea.base64ToBlob(comprobanteXML, 'application/xml'), "Comprobante.xml");
        }
    }

    OnTimbrarFactura = async () => {
        const serieFolio = this.props.factura.SerieFolio;
        if (await kea.yesno("¿Timbrar factura: " + serieFolio + "?")) {
            const idFactura = this.props.factura.IdRegistro;
            await resources.FacturacionOnline.TimbrarFacturaOnline(idFactura);
            await this.props.onFacturar();
            await kea.message("Se ha timbrado la factura");
            location.reload();
        }
    }

    OnObtenerPDF = async () => {
        const idFactura = this.props.factura.IdRegistro;
        if (idFactura != null) {
            const facturaPDF = await resources.Factura.ObtenerPDF(idFactura);
            kea.download(kea.base64ToBlob(facturaPDF, 'application/pdf'), "Comprobante.pdf");
        }
    }

    render() {
        const value = this.props.value;
        const facturaOnline = this.facturaOnline(this.props);
        const receptorFactura = this.receptor(this.props);
        const correoFacturacion = this.correoFacturacion(this.props);

        const factura = this.factura(this.props);
        const existeGuia = this.existeGuia(this.props);
        const hasError = this.hasError(this.props);

        return (
            <div>
                {
                    existeGuia ?
                        <div>
                            <h2 style={{ fontFamily: "monospace" }}>{value.Folio}</h2>
                            <br />

                            <ResumenGuiaView value={{
                                CantidadPaquetes: value.CantidadPaquetes,
                                CantidadSobres: value.CantidadSobres,
                                EsDeAcuse: value.EsDeAcuse,
                                FolioGuiaAcuse: value.FolioGuiaAcuse,
                                NombreSucursalOrigen: value.NombreSucursalOrigen,
                                NombreSucursalDestino: value.NombreSucursalDestino,
                                Status: value.StatusActual,
                                NombreSucursalStatus: value.NombreSucursalActual,
                                Folio: value.Folio
                            }} puedeVerDatosEntregaCliente={false} />
                            <hr />

                            <label>Cliente origen: </label>{value.NombreClienteOrigen}<br />
                            <label>Dirección origen: </label>{value.NombreDireccionOrigen}<br />
                            <label>Cliente destino: </label>{value.NombreClienteDestino}<br />
                            <label>Dirección destino: </label>{value.NombreDireccionDestino}<br />

                            <br />
                            {
                                !value.EsFacturada &&
                                <div>

                                    {kea.autogrid(6, [
                                        <ReceptorFactura value={receptorFactura} onChange={this.onReceptorChange} readonly={false} />,
                                        <kea.Text value={correoFacturacion} onChange={this.onCorreoChange} label="Correo facturación:" />
                                    ])}
                                    <div className="row">
                                        <div className="col-md-12">
                                            <DireccionFacturacionComponent value={facturaOnline} onChange={this.props.onChange} />
                                        </div>
                                    </div>,
                                    <kea.Button style="success" children="Facturar" onClick={this.onFacturarGuia} disabled={hasError} />
                                </div>
                            }
                            {
                                (factura != null && value.EsFacturada) &&
                                <div>
                                    {
                                        (value.EsTimbrada && !value.EsDePublicoGeneral) &&
                                        <div>
                                            <kea.Button iconClass={fa("file-code-o")} tooltip="Obtener archivo xml de la factura expedido por el SAT" children="Descargar Factura XML" style="primary" onClick={this.OnObtenerXML} />
                                            <kea.Button iconClass={fa("file-pdf-o")} tooltip="Obtener archivo pdf de la factura" children="Descargar Factura PDF" style="danger" onClick={this.OnObtenerPDF} />
                                        </div>
                                    }
                                    {
                                        (!value.EsTimbrada && !value.EsDePublicoGeneral) &&
                                        <div className="alert alert-info">
                                            <label>La guía está facturada pero no timbrada ante el SAT</label>
                                            <br />
                                            <kea.Button iconClass={fa("bell")} tooltip="Timbrar factura en el SAT" children="Timbrar factura" style="warning" onClick={this.OnTimbrarFactura} />
                                        </div>
                                    }
                                    <FacturaGuia factura={factura} />
                                </div>
                            }

                        </div>
                        : <div className="alert alert-info">
                            <label>No hay guías que concuerden con los datos agregados</label>
                            <br />
                            Verifiqué los datos de busqueda de <b>facturación</b>
                        </div>
                }
            </div>
        )
    }
}

export const ResumenGuiaAFacturar = componentToRx(ResumenFacturacionViewNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturaciononline/edit/resumen.tsx